import type { GuideProductGroupInfo } from '../types';

interface ResolveGuideProductPoolInfoParams {
  group?: GuideProductGroupInfo | null;
  fallbackTitle?: string;
}

export function resolveGuideProductPoolInfo({
  group,
  fallbackTitle,
}: ResolveGuideProductPoolInfoParams) {
  const bannerDownInfo = group?.banner_down_info || {};

  return {
    title: bannerDownInfo.title || fallbackTitle || '',
    subtitle: bannerDownInfo.desc || '',
  };
}
